// firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, GithubAuthProvider, TwitterAuthProvider, OAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, deleteUser } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: "AIzaSyDQf2BX0lphd9NN6UC7aN6NbLMgMfvPd6I",
//   authDomain: "ukinews-abec9.firebaseapp.com",
//   projectId: "ukinews-abec9",
//   storageBucket: "ukinews-abec9.firebasestorage.app",
//   messagingSenderId: "567632916048",
//   appId: "1:567632916048:web:0a69dc084c1306c26cab55"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBXNoSn2YDo7V7HaJh8oV_AtAkEfe1ikyM",
  authDomain: "ukicnews-login.firebaseapp.com",
  projectId: "ukicnews-login",
  storageBucket: "ukicnews-login.firebasestorage.app",
  messagingSenderId: "288965683716",
  appId: "1:288965683716:web:60d91eb4bf4e306d8d2351",
  measurementId: "G-X0RSQS0W9G"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Providers
const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();
const twitterAuthProvider = new TwitterAuthProvider();
const yahooAuthProvider = new OAuthProvider("yahoo.com");

export { auth, googleProvider, githubProvider, twitterAuthProvider, yahooAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword };